import { createQuery } from './core';
// PUBLIC API
export const getOrganizationMemberships = createQuery('operations/get-organization-memberships', ['OrganizationMembership', 'User', 'Organization']);
// PUBLIC API
export const getUserOrganizationMemberships = createQuery('operations/get-user-organization-memberships', ['OrganizationMembership', 'Organization', 'User']);
// PUBLIC API
export const getMyFollowedOrganizations = createQuery('operations/get-my-followed-organizations', ['OrganizationMembership', 'Organization']);
// PUBLIC API
export const getSiteAccessStatus = createQuery('operations/get-site-access-status', ['GlobalSettings']);
// PUBLIC API
export const getSiteAccessSettings = createQuery('operations/get-site-access-settings', ['GlobalSettings']);
// PUBLIC API
export const getPaginatedUsers = createQuery('operations/get-paginated-users', ['User']);
// PUBLIC API
export const getUserById = createQuery('operations/get-user-by-id', ['User', 'LocationMembership', 'Location']);
// PUBLIC API
export const getDeletedUsers = createQuery('operations/get-deleted-users', ['User', 'Location']);
// PUBLIC API
export const getPendingUsers = createQuery('operations/get-pending-users', ['User']);
// PUBLIC API
export const getGptResponses = createQuery('operations/get-gpt-responses', ['User', 'GptResponse']);
// PUBLIC API
export const getAllTasksByUser = createQuery('operations/get-all-tasks-by-user', ['Task']);
// PUBLIC API
export const getCustomerPortalUrl = createQuery('operations/get-customer-portal-url', ['User']);
// PUBLIC API
export const getAllFilesByUser = createQuery('operations/get-all-files-by-user', ['User', 'File']);
// PUBLIC API
export const getDownloadFileSignedURL = createQuery('operations/get-download-file-signed-url', ['User', 'File']);
// PUBLIC API
export const getDailyStats = createQuery('operations/get-daily-stats', ['User', 'DailyStats']);
// PUBLIC API
export const getOrganizationTypes = createQuery('operations/get-organization-types', ['OrganizationType']);
// PUBLIC API
export const getOrganizationTypeById = createQuery('operations/get-organization-type-by-id', ['OrganizationType', 'Organization']);
// PUBLIC API
export const getOrganizationTypeByKey = createQuery('operations/get-organization-type-by-key', ['OrganizationType']);
// PUBLIC API
export const getOrganizationsByTypeKey = createQuery('operations/get-organizations-by-type-key', ['Organization', 'OrganizationType']);
// PUBLIC API
export const getOrgTypeSections = createQuery('operations/get-org-type-sections', ['OrgTypeSection', 'Section']);
// PUBLIC API
export const getOrgTypeServiceTypes = createQuery('operations/get-org-type-service-types', ['OrgTypeServiceType', 'ServiceType', 'ServiceDefinition']);
// PUBLIC API
export const getOrgTypeTopicTypes = createQuery('operations/get-org-type-topic-types', ['OrgTypeTopicType', 'TopicType', 'Topic']);
// PUBLIC API
export const getLocationTypes = createQuery('operations/get-location-types', ['LocationType']);
// PUBLIC API
export const getLocationTypeById = createQuery('operations/get-location-type-by-id', ['LocationType', 'Location']);
// PUBLIC API
export const getLocTypeServiceTypes = createQuery('operations/get-loc-type-service-types', ['LocTypeServiceType', 'ServiceType', 'ServiceDefinition']);
// PUBLIC API
export const getLocTypeTopicTypes = createQuery('operations/get-loc-type-topic-types', ['LocTypeTopicType', 'TopicType', 'Topic']);
// PUBLIC API
export const getSections = createQuery('operations/get-sections', ['Section', 'SectionTranslation']);
// PUBLIC API
export const getSectionById = createQuery('operations/get-section-by-id', ['Section', 'SectionTranslation']);
// PUBLIC API
export const getOccasionTypes = createQuery('operations/get-occasion-types', ['OccasionType']);
// PUBLIC API
export const getOccasionTypeById = createQuery('operations/get-occasion-type-by-id', ['OccasionType', 'Occasion']);
// PUBLIC API
export const getOccasionById = createQuery('operations/get-occasion-by-id', ['Occasion', 'OccasionType', 'TopicOccasion', 'OccasionServiceDefinition', 'Event', 'LocationOccasion']);
// PUBLIC API
export const getOrganizations = createQuery('operations/get-organizations', ['Organization', 'OrganizationType', 'LocationOrganization']);
// PUBLIC API
export const getOrganizationById = createQuery('operations/get-organization-by-id', ['Organization', 'OrganizationType', 'LocationOrganization', 'Location', 'OrgSectionContent']);
// PUBLIC API
export const getLocationOrganizations = createQuery('operations/get-location-organizations', ['LocationOrganization', 'Organization', 'OrganizationType']);
// PUBLIC API
export const getOrganizationLocations = createQuery('operations/get-organization-locations', ['LocationOrganization', 'Location']);
// PUBLIC API
export const getFieldConfigs = createQuery('operations/get-field-configs', ['FieldConfig']);
// PUBLIC API
export const getFieldConfigsForContentType = createQuery('operations/get-field-configs-for-content-type', ['FieldConfig']);
// PUBLIC API
export const getFieldConfigById = createQuery('operations/get-field-config-by-id', ['FieldConfig']);
// PUBLIC API
export const getGlobalSettings = createQuery('operations/get-global-settings', ['GlobalSettings']);
// PUBLIC API
export const getGlobalSettingByKey = createQuery('operations/get-global-setting-by-key', ['GlobalSettings']);
// PUBLIC API
export const getSectionVisibility = createQuery('operations/get-section-visibility', ['SectionVisibility']);
// PUBLIC API
export const getSectionVisibilityByKey = createQuery('operations/get-section-visibility-by-key', ['SectionVisibility']);
// PUBLIC API
export const getGlobalAdmins = createQuery('operations/get-global-admins', ['User']);
// PUBLIC API
export const getBulkUploadEnabled = createQuery('operations/get-bulk-upload-enabled', ['GlobalSettings']);
// PUBLIC API
export const getRegistrationOpen = createQuery('operations/get-registration-open', ['GlobalSettings']);
// PUBLIC API
export const getCommunityEnabled = createQuery('operations/get-community-enabled', ['GlobalSettings']);
// PUBLIC API
export const getOrganizationsEnabled = createQuery('operations/get-organizations-enabled', ['GlobalSettings']);
// PUBLIC API
export const getBuySellFormMode = createQuery('operations/get-buy-sell-form-mode', ['GlobalSettings']);
// PUBLIC API
export const getSimplifiedFormEnabled = createQuery('operations/get-simplified-form-enabled', ['GlobalSettings']);
// PUBLIC API
export const getPlatformTheme = createQuery('operations/get-platform-theme', ['GlobalSettings']);
// PUBLIC API
export const getGlobalModerators = createQuery('operations/get-global-moderators', ['User']);
// PUBLIC API
export const getBulkImportHistory = createQuery('operations/get-bulk-import-history', ['BulkImportHistory']);
// PUBLIC API
export const getLocations = createQuery('operations/get-locations', ['Location', 'LocationMembership']);
// PUBLIC API
export const getMySubscribedLocations = createQuery('operations/get-my-subscribed-locations', ['Location', 'LocationMembership']);
// PUBLIC API
export const getMyLocationNavSettings = createQuery('operations/get-my-location-nav-settings', ['Location', 'LocationMembership', 'User']);
// PUBLIC API
export const getLocationBySlug = createQuery('operations/get-location-by-slug', ['Location', 'LocationMembership']);
// PUBLIC API
export const getUserMembership = createQuery('operations/get-user-membership', ['LocationMembership']);
// PUBLIC API
export const getLocationContentApprovalSettings = createQuery('operations/get-location-content-approval-settings', ['Location', 'LocationMembership']);
// PUBLIC API
export const getAllLocations = createQuery('operations/get-all-locations', ['Location']);
// PUBLIC API
export const getLocationById = createQuery('operations/get-location-by-id', ['Location', 'LocationType']);
// PUBLIC API
export const getLocationItems = createQuery('operations/get-location-items', ['Location', 'LocationMembership', 'Content', 'Event', 'User']);
// PUBLIC API
export const getLocationWithChildren = createQuery('operations/get-location-with-children', ['Location']);
// PUBLIC API
export const getHubLocations = createQuery('operations/get-hub-locations', ['Location']);
// PUBLIC API
export const getLocationContent = createQuery('operations/get-location-content', ['Content', 'Location', 'LocationMembership', 'User']);
// PUBLIC API
export const getEvents = createQuery('operations/get-events', ['Event', 'Location', 'User', 'LocationMembership', 'Organization']);
// PUBLIC API
export const getEventById = createQuery('operations/get-event-by-id', ['Event', 'Location', 'User', 'LocationMembership', 'EventAttendee']);
// PUBLIC API
export const getLocationEvents = createQuery('operations/get-location-events', ['Event', 'LocationMembership', 'User']);
// PUBLIC API
export const getInvestOttawaEventsSyncStatus = createQuery('operations/get-invest-ottawa-events-sync-status', ['GlobalSettings']);
// PUBLIC API
export const getTenants = createQuery('operations/get-tenants', ['Tenant', 'Location', 'Organization']);
// PUBLIC API
export const getTenantById = createQuery('operations/get-tenant-by-id', ['Tenant', 'Location']);
// PUBLIC API
export const getNotices = createQuery('operations/get-notices', ['Content', 'Location', 'User', 'LocationMembership']);
// PUBLIC API
export const getLocationNotices = createQuery('operations/get-location-notices', ['Content', 'Location', 'LocationMembership', 'User', 'Organization']);
// PUBLIC API
export const getNoticeById = createQuery('operations/get-notice-by-id', ['Content', 'Location', 'User', 'LocationMembership']);
// PUBLIC API
export const getFacilities = createQuery('operations/get-facilities', ['Content', 'Location', 'User', 'LocationMembership', 'Organization']);
// PUBLIC API
export const getFacilityById = createQuery('operations/get-facility-by-id', ['Content', 'Location', 'User', 'LocationMembership']);
// PUBLIC API
export const getBuySells = createQuery('operations/get-buy-sells', ['Content', 'Location', 'User', 'Organization']);
// PUBLIC API
export const getBuySellById = createQuery('operations/get-buy-sell-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getRequestOffers = createQuery('operations/get-request-offers', ['Content', 'Location', 'User', 'Organization']);
// PUBLIC API
export const getRequestOfferById = createQuery('operations/get-request-offer-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getTransportations = createQuery('operations/get-transportations', ['Content', 'Location', 'User', 'Organization']);
// PUBLIC API
export const getTransportationById = createQuery('operations/get-transportation-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getFoodCourtItems = createQuery('operations/get-food-court-items', ['Content', 'Location', 'User', 'Organization']);
// PUBLIC API
export const getFoodCourtItemById = createQuery('operations/get-food-court-item-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getLostFoundItems = createQuery('operations/get-lost-found-items', ['Content', 'Location', 'User', 'Organization']);
// PUBLIC API
export const getLostFoundItemById = createQuery('operations/get-lost-found-item-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const getServices = createQuery('operations/get-services', ['Content', 'Location', 'User', 'Organization']);
// PUBLIC API
export const getServiceById = createQuery('operations/get-service-by-id', ['Content', 'Location', 'User']);
// PUBLIC API
export const globalSearch = createQuery('operations/global-search', ['Content', 'Event', 'Tenant', 'Location', 'Organization']);
// PUBLIC API
export const getUserPermissions = createQuery('operations/get-user-permissions', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const getPendingApprovals = createQuery('operations/get-pending-approvals', ['ApprovalRequest', 'Content', 'User', 'Location', 'LocationPermission', 'LocationMembership', 'Notification', 'Organization', 'OrganizationMembership']);
// PUBLIC API
export const getUsersWithPermissions = createQuery('operations/get-users-with-permissions', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const getMyPermissions = createQuery('operations/get-my-permissions', ['LocationPermission', 'User', 'Location', 'LocationMembership']);
// PUBLIC API
export const getLocationAdminsAndManagers = createQuery('operations/get-location-admins-and-managers', ['LocationPermission', 'User', 'Location']);
// PUBLIC API
export const getAllLocationsForPermissions = createQuery('operations/get-all-locations-for-permissions', ['Location', 'LocationPermission']);
// PUBLIC API
export const getApprovalHistory = createQuery('operations/get-approval-history', ['ApprovalRequest', 'Content', 'User', 'Location']);
// PUBLIC API
export const getApprovalStats = createQuery('operations/get-approval-stats', ['ApprovalRequest', 'Content', 'User', 'Location']);
// PUBLIC API
export const getNotifications = createQuery('operations/get-notifications', ['Notification', 'User', 'Location']);
// PUBLIC API
export const getUnreadNotificationCount = createQuery('operations/get-unread-notification-count', ['Notification', 'User']);
// PUBLIC API
export const getNotificationPreferences = createQuery('operations/get-notification-preferences', ['User', 'UserNotificationPreference', 'LocationMembership', 'Location']);
// PUBLIC API
export const getRecycleBinEntries = createQuery('operations/get-recycle-bin-entries', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const getRecycleBinEntry = createQuery('operations/get-recycle-bin-entry', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const getRecycleBinStats = createQuery('operations/get-recycle-bin-stats', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const getEntriesScheduledForDeletion = createQuery('operations/get-entries-scheduled-for-deletion', ['ContentRecycleBin', 'User', 'Location']);
// PUBLIC API
export const getOccasions = createQuery('operations/get-occasions', ['Occasion', 'OccasionType', 'LocationOccasion', 'Location']);
// PUBLIC API
export const getOccasionBySlug = createQuery('operations/get-occasion-by-slug', ['Occasion', 'OccasionType', 'LocationOccasion', 'Location', 'Event', 'User']);
// PUBLIC API
export const getActiveOccasions = createQuery('operations/get-active-occasions', ['Occasion', 'OccasionType']);
// PUBLIC API
export const getOccasionsByLocation = createQuery('operations/get-occasions-by-location', ['Occasion', 'OccasionType', 'LocationOccasion', 'Location']);
// PUBLIC API
export const getTopics = createQuery('operations/get-topics', ['Topic', 'TopicType', 'TopicService', 'TopicOccasion', 'Content', 'Occasion']);
// PUBLIC API
export const getTopicBySlug = createQuery('operations/get-topic-by-slug', ['Topic', 'TopicType', 'TopicService', 'TopicOccasion', 'Content', 'Occasion', 'OccasionType', 'Event', 'Location', 'User']);
// PUBLIC API
export const getTopicById = createQuery('operations/get-topic-by-id', ['Topic', 'TopicType']);
// PUBLIC API
export const getActiveTopics = createQuery('operations/get-active-topics', ['Topic', 'TopicType']);
// PUBLIC API
export const getTopicsByType = createQuery('operations/get-topics-by-type', ['Topic', 'TopicType', 'TopicService', 'TopicOccasion', 'Content', 'Occasion', 'Location']);
// PUBLIC API
export const getTopicTypes = createQuery('operations/get-topic-types', ['TopicType']);
// PUBLIC API
export const getTopicTypeById = createQuery('operations/get-topic-type-by-id', ['TopicType', 'Topic']);
// PUBLIC API
export const getServiceTypes = createQuery('operations/get-service-types', ['ServiceType', 'ServiceDefinition']);
// PUBLIC API
export const getServiceTypeByKey = createQuery('operations/get-service-type-by-key', ['ServiceType', 'ServiceDefinition']);
// PUBLIC API
export const getServiceTypeById = createQuery('operations/get-service-type-by-id', ['ServiceType', 'ServiceDefinition']);
// PUBLIC API
export const getServiceDefinitions = createQuery('operations/get-service-definitions', ['ServiceDefinition', 'ServiceType', 'ServiceOffering']);
// PUBLIC API
export const getServiceDefinitionBySlug = createQuery('operations/get-service-definition-by-slug', ['ServiceDefinition', 'ServiceType', 'ServiceOffering', 'Location', 'Organization', 'TopicServiceDefinition', 'Topic', 'TopicType', 'OccasionServiceDefinition', 'Occasion', 'OccasionType']);
// PUBLIC API
export const getServiceDefinitionById = createQuery('operations/get-service-definition-by-id', ['ServiceDefinition', 'ServiceType', 'ServiceOffering', 'TopicServiceDefinition', 'OccasionServiceDefinition']);
// PUBLIC API
export const getServiceDefinitionsByTopic = createQuery('operations/get-service-definitions-by-topic', ['ServiceDefinition', 'ServiceType', 'TopicServiceDefinition', 'Topic', 'ServiceOffering']);
// PUBLIC API
export const getServiceDefinitionsByOccasion = createQuery('operations/get-service-definitions-by-occasion', ['ServiceDefinition', 'ServiceType', 'OccasionServiceDefinition', 'Occasion', 'ServiceOffering']);
// PUBLIC API
export const getServiceOfferings = createQuery('operations/get-service-offerings', ['ServiceOffering', 'ServiceDefinition', 'ServiceType', 'Location', 'Organization', 'Event']);
// PUBLIC API
export const getServiceOfferingById = createQuery('operations/get-service-offering-by-id', ['ServiceOffering', 'ServiceDefinition', 'ServiceType', 'Location', 'LocationType', 'Organization', 'OrganizationType', 'Event', 'TopicServiceDefinition', 'Topic', 'TopicType', 'OccasionServiceDefinition', 'Occasion', 'OccasionType']);
// PUBLIC API
export const getServiceOfferingsByLocation = createQuery('operations/get-service-offerings-by-location', ['ServiceOffering', 'ServiceDefinition', 'ServiceType', 'Location', 'Organization']);
// PUBLIC API
export const getServiceOfferingsByOrganization = createQuery('operations/get-service-offerings-by-organization', ['ServiceOffering', 'ServiceDefinition', 'ServiceType', 'Location', 'Organization']);
// PUBLIC API
export const getUpcomingServices = createQuery('operations/get-upcoming-services', ['ServiceOffering', 'ServiceDefinition', 'ServiceType', 'Location', 'Organization']);
// PUBLIC API
export const searchServices = createQuery('operations/search-services', ['ServiceDefinition', 'ServiceType', 'ServiceOffering', 'Location', 'Organization']);
// PUBLIC API
export const getRelatedServices = createQuery('operations/get-related-services', ['ServiceDefinition', 'ServiceType', 'ServiceOffering', 'Location', 'Organization', 'TopicServiceDefinition', 'OccasionServiceDefinition']);
// PUBLIC API
export const getCanadaProvinces = createQuery('operations/get-canada-provinces', ['CanadaProvince']);
// PUBLIC API
export const getCanadaProvinceById = createQuery('operations/get-canada-province-by-id', ['CanadaProvince', 'CanadaMunicipality']);
// PUBLIC API
export const getCanadaMunicipalities = createQuery('operations/get-canada-municipalities', ['CanadaMunicipality', 'CanadaProvince']);
// PUBLIC API
export const getCanadaMunicipalityById = createQuery('operations/get-canada-municipality-by-id', ['CanadaMunicipality', 'CanadaProvince']);
// PUBLIC API
export const getCanadaNeighbourhoods = createQuery('operations/get-canada-neighbourhoods', ['CanadaNeighbourhood', 'CanadaMunicipality', 'CanadaProvince', 'CanadaNeighbourhoodFsa']);
// PUBLIC API
export const getCanadaNeighbourhoodById = createQuery('operations/get-canada-neighbourhood-by-id', ['CanadaNeighbourhood', 'CanadaMunicipality', 'CanadaProvince', 'CanadaSuburb', 'CanadaNeighbourhoodFsa']);
// PUBLIC API
export const getCanadaSuburbs = createQuery('operations/get-canada-suburbs', ['CanadaSuburb', 'CanadaMunicipality', 'CanadaProvince']);
// PUBLIC API
export const getCanadaSuburbById = createQuery('operations/get-canada-suburb-by-id', ['CanadaSuburb', 'CanadaMunicipality', 'CanadaProvince']);
// PUBLIC API
export const getOrganizationBySlug = createQuery('operations/get-organization-by-slug', ['Organization', 'OrganizationType', 'OrgTypeSection', 'Section', 'SectionTranslation', 'LocationOrganization', 'LocationSection', 'Location']);
// PUBLIC API
export const getOrganizationsByLocationSlug = createQuery('operations/get-organizations-by-location-slug', ['Organization', 'OrganizationType', 'LocationOrganization', 'Location']);
// PUBLIC API
export const getSidebarOrganizations = createQuery('operations/get-sidebar-organizations', ['Organization', 'LocationOrganization', 'Location']);
// PUBLIC API
export const getNationalOrganizations = createQuery('operations/get-national-organizations', ['Organization', 'OrganizationType']);
// PUBLIC API
export const getOrgSectionContent = createQuery('operations/get-org-section-content', ['OrgSectionContent', 'Organization']);
// PUBLIC API
export const getUserReports = createQuery('operations/get-user-reports', ['UserReport', 'User']);
// PUBLIC API
export const getTeamMembers = createQuery('operations/get-team-members', ['TeamMember', 'Location', 'LocationMembership']);
// PUBLIC API
export const getInfoSections = createQuery('operations/get-info-sections', ['InfoSection', 'Location', 'LocationMembership']);
// PRIVATE API (used in SDK)
export { buildAndRegisterQuery } from './core';
//# sourceMappingURL=index.js.map